module.exports = __webpack_public_path__ + "static/media/books.32171a74.svg";